module.exports = __webpack_public_path__ + "Server-Healthy.TentacleActive.8a841bcb9dfefbfd412780cdf425574a.hashedasset.svg";